module.exports = {
    AT_HOME_ABROAD_PRODUCT_NAME : 'At Home Abroad Card',
    DIAMOND_PACK_PRODUCT_NAME : 'Diamond Card',
    E_CARD_PRODUCT_NAME : 'E Card',
    E_CARD_PRODUCT_TYPE : 'E_CARD',
    HORMIGUERO_CARD_PRODUCT_NAME: 'El Hormiguero Card',
    MINI_CARD_PRODUCT_NAME : 'Mini Card',
    NERUDA_CARD_PRODUCT_NAME: 'Neruda Card',
    OPEN_CREDIT_CARD_PRODUCT_NAME : 'Open Credit Card',
    OPEN_DEBIT_CARD_PRODUCT_NAME : 'Open Debit Card',
    OPEN_YOUNG_ACCOUNT_PRODUCT_NAME : 'Open Young Account',
    OPEN_YOUNG_CARD_PRODUCT_NAME : 'Open Young Card',
    PAYROLL_ACCOUNT_PRODUCT_NAME : 'Payroll Account',
    PREMIUM_PACK_PRODUCT_NAME : 'Premium Card',
    SOLIDARITY_CARD_PRODUCT_NAME : 'Solidarity Card',
    UPGRADE_TO_PAYROLL_ACCOUNT_PRODUCT_NAME : 'Upgrade to Payroll Account',
    VANITY_CARD_PRODUCT_NAME: 'Vanity Fair Card',
    VIA_T_CARD_PRODUCT_NAME : 'Via-T Card',
    VIRTUAL_CREDIT_CARD_PRODUCT_NAME : 'Virtual Credit Card',
    VIRTUAL_DEBIT_CARD_PRODUCT_NAME : 'Virtual Debit Card',
}